import { useEffect, useState } from 'react';
import { Drawer, Grid, Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const { Sider, Content } = Layout;

// Título de la pestaña del navegador según la ruta (prefijo más largo gana).
const TITLES: Array<[string, string]> = [
  ['/cuentas', 'Cuentas'],
  ['/contactos', 'Contactos'],
  ['/proyectos', 'Proyectos'],
  ['/ventas', 'Ventas'],
  ['/actividades', 'Actividades'],
  ['/reportes', 'Reportes'],
  ['/perfil', 'Mi perfil'],
  ['/admin/usuarios', 'Usuarios'],
  ['/admin/etiquetas', 'Etiquetas'],
  ['/admin/catalogos', 'Catálogos'],
  ['/admin/auditoria', 'Auditoría'],
  ['/', 'Inicio'],
];

function titleForPath(pathname: string): string {
  const match = TITLES.filter(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`))
    .sort((a, b) => b[0].length - a[0].length)[0];
  return match ? match[1] : '';
}

export function AppLayout(): JSX.Element {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const screens = Grid.useBreakpoint();
  const location = useLocation();
  // `lg` o más → escritorio con sidebar fijo; abajo de eso → drawer en móvil.
  const isMobile = !screens.lg;

  useEffect(() => {
    const section = titleForPath(location.pathname);
    document.title = section ? `${section} · never2busy` : 'never2busy';
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {isMobile ? (
        <Drawer
          placement="left"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          width={240}
          closable={false}
          styles={{ body: { padding: 0 } }}
        >
          <Sidebar collapsed={false} onNavigate={() => setMobileOpen(false)} />
        </Drawer>
      ) : (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          theme="light"
          width={240}
          style={{ borderRight: '1px solid #f0f0f0' }}
        >
          <Sidebar collapsed={collapsed} />
        </Sider>
      )}
      <Layout>
        <Topbar showMenuButton={isMobile} onMenuClick={() => setMobileOpen(true)} />
        <Content
          style={{ margin: 0, padding: isMobile ? 12 : 24, background: '#f5f5f5' }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 8,
              padding: isMobile ? 16 : 24,
              minHeight: 'calc(100vh - 112px)',
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
